import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

import DeletePaymentFormModal from 'src/features/payments/components/forms/DeletePaymentFormModal';
import { Payment } from 'src/features/payments/utils/types';
import { Link } from 'react-router-dom';
import UpdatePaymentFormModal from 'src/features/payments/components/forms/UpdatePaymentFormModal';
import { paymentsMessages } from 'src/features/payments/utils/messages';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

export default function CellPaymentActions({ row }: CellContext<Payment, unknown>) {
    const { formatMessage } = useIntl();

    const paymentAllocatedAmount = row.original.allocated_amount;
    const hideEditDeleteButtons = paymentAllocatedAmount > 0;

    const permissionManagePayments = useHasPermissions([PERMISSION.MANAGE_PAYMENTS]);

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`/payments/${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.dashboard} />
                    </TooltipContent>
                </Tooltip>
                {permissionManagePayments && !hideEditDeleteButtons && (
                    <>
                        <Tooltip>
                            <UpdatePaymentFormModal
                                semantics={{ entryName: formatMessage(paymentsMessages.payment).toLowerCase() }}
                                selectedPayment={row.original}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                    </Button>
                                </TooltipTrigger>
                            </UpdatePaymentFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.edit} />
                            </TooltipContent>
                        </Tooltip>
                        <Tooltip>
                            <DeletePaymentFormModal selectedPayment={row.original}>
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                    </Button>
                                </TooltipTrigger>
                            </DeletePaymentFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.delete} />
                            </TooltipContent>
                        </Tooltip>
                    </>
                )}
            </TooltipProvider>
        </div>
    );
}
